import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPDATE_WORKSPACE_BIDDER_FOR_FORM: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updateWorkspaceBidderForForm($input: UpdateWorkspaceBidderInput!) {
    updateWorkspaceBidder(input: $input) {
      workspaceBidder {
        id
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
